import { Skeleton } from '../../../../../Skeleton'
import { LISTING_PERFORMANCE_TILE_COUNT } from '../RentalPortalListingProfileWidgetPerformance.constants'

import * as styles from './ListingProfileWidgetPerformanceSkeleton.module.css'

function ListingProfileWidgetPerformanceSkeleton() {
  return (
    <div className={styles.ListingProfileWidgetPerformanceSkeleton}>
      {Array.from({ length: LISTING_PERFORMANCE_TILE_COUNT }).map(
        (_, index) => (
          <div className={styles.tile} key={index}>
            <Skeleton className={styles.value} />
            <Skeleton className={styles.label} />
          </div>
        )
      )}
    </div>
  )
}

export default ListingProfileWidgetPerformanceSkeleton
